import React, { useEffect, useState } from 'react';
import { getToken, isSupported } from 'firebase/messaging';
import { messaging, auth } from '../../config/firebase';
import secureAxios from '../../utils/secureAxios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import './EnableNotifications.css';

const vapidKey = 'BL9Hx_1JRfrSusv698qSJJBpIEdSRlz0JLkBblwSxRx6jOai8OIc0enx6KEfQ2KKa2smi4TscsZJ-fv4HJqbjM0';

export default function EnableNotifications() {
    const [visible, setVisible] = useState(false);
    const [success, setSuccess] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isChecking, setIsChecking] = useState(true); // Nuevo estado para controlar la verificación inicial

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setIsAuthenticated(true);

                const rechazado = localStorage.getItem('notificaciones-rechazadas');
                const activado = localStorage.getItem('notificaciones-activadas');

                if (!rechazado && !activado) {
                    const timeout = setTimeout(() => setVisible(true), 1000);
                    setIsChecking(false); // Terminar verificación después del timeout
                    return () => clearTimeout(timeout);
                } else {
                    setIsChecking(false); // Terminar verificación inmediatamente si ya hay una preferencia
                }
            } else {
                setIsAuthenticated(false);
                setIsChecking(false); // Terminar verificación si no está autenticado
            }
        });

        return () => unsubscribe();
    }, []);

    const activar = async () => {
        setVisible(false);
        localStorage.setItem('notificaciones-activadas', 'true');

        const soportado = await isSupported();
        if (!soportado) {
            alert('Este navegador no soporta notificaciones push.');
            return;
        }

        try {
            const permiso = await Notification.requestPermission();
            if (permiso !== 'granted') {
                alert('Debes permitir las notificaciones.');
                return;
            }

            const token = await getToken(messaging, { vapidKey });
            if (token) {
                const cleanedToken = token.trim().replace(/^"|"$/g, '');

                await secureAxios.post('/push/register-token', { fcmToken: cleanedToken });
                setSuccess(true);
                setTimeout(() => setSuccess(false), 4000);
            }
        } catch (err) {
            console.error('Error activando notificaciones:', err);
            alert('Error al activar notificaciones');
        }
    };

    const rechazar = () => {
        localStorage.setItem('notificaciones-rechazadas', 'true');
        setVisible(false);
    };

    if (!isAuthenticated || isChecking || (!visible && !success)) return null;

    return (
        <div className="notif-container show">
            <div className="notif-box">
                {success ? (
                    <div className="notif-success">
                        <FontAwesomeIcon icon={faCircleCheck} /> Notificaciones activadas correctamente
                    </div>
                ) : (
                    <>
                        <p className="notif-text">¿Deseas activar las notificaciones?</p>
                        <div className="notif-buttons">
                            <button className="notif-btn accept" onClick={activar}>Sí</button>
                            <button className="notif-btn reject" onClick={rechazar}>No</button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
